export class Scheduler {
  static addTask = (() => {
    let pending = Promise.resolve();
    const run = async (cb) => {
      try {
        await pending;
      } finally {
        // console.log(cb);
        // tslint:disable-next-line: no-unsafe-finally
        return cb();
      }
    };

    return (cb) => (pending = run(cb));
  })();
}
